import axios from 'axios';

const LEONARDO_API_KEY = '01924f8a-78dc-41ad-a041-326e96308a0c';

// Кэш для отслеживания активных запросов
const activeRequests = new Map();
// Кэш для результатов
const resultsCache = new Map();
// Время жизни блокировки повторного запроса (15 секунд)
const LOCK_TIMEOUT = 15000;

export const generateFoodImage = async (recipe) => {
  console.log('🚀 generateFoodImage', recipe);
  if (!recipe?.title) return null;
  
  const cacheKey = `${recipe.title}_${recipe.usedIngredients?.join('_')}`;
  
  // Проверяем кэш результатов
  if (resultsCache.has(cacheKey)) {
    console.log('📦 Returning cached result for:', recipe.title);
    return resultsCache.get(cacheKey);
  }

  // Проверяем, не выполняется ли уже запрос
  if (activeRequests.has(cacheKey)) {
    const { promise, timestamp } = activeRequests.get(cacheKey);
    
    // Если запрос не старше LOCK_TIMEOUT, возвращаем существующий промис
    if (Date.now() - timestamp < LOCK_TIMEOUT) {
      console.log('🔒 Request in progress for:', recipe.title);
      return promise;
    }
    // Если запрос застарел, удаляем его
    activeRequests.delete(cacheKey);
  }

  console.log('🎨 generateFoodImage called for:', recipe?.title);
  
  try {
    const requestId = Math.random().toString(36).substring(7);
    console.log(`📡 [${requestId}] Starting Leonardo API request for:`, recipe?.title);

    // Создаем промис для текущего запроса
    const promise = (async () => {
      const prompt = `
        Cinematic editorial-style food photo capturing the dish "${recipe.title}", 
        shot on a ~70mm lens with a shallow depth of field (f/3.5).
        Focus on crisp, photoreal textures, vibrant colors, and fresh details.
        No visible steam, smoke, or vapors.
        Description: ${recipe.aidescription}
      `.trim();

      const postResponse = await axios.post(
        'https://cloud.leonardo.ai/api/rest/v1/generations',
        {
          prompt,
          modelId: 'b2614463-296c-462a-9586-aafdb8f00e36',
          width: 800,
          height: 992,
          num_images: 1,
          negative_prompt: 'steam, smoke, vapor, haze, fog, mist',
          alchemy: false,
          contrast: 3,
          styleUUID: '7c3f932b-a572-47cb-9b9b-f20211e63b5b'
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${LEONARDO_API_KEY}`,
          },
        }
      );

      const generationId = postResponse.data.sdGenerationJob.generationId;
      console.log(`✨ [${requestId}] Got generation ID:`, generationId);
      
      const maxAttempts = 10;
      let attempt = 0;

      while (attempt < maxAttempts) {
        attempt++;
        await new Promise(resolve => setTimeout(resolve, 3000));

        const getResponse = await axios.get(
          `https://cloud.leonardo.ai/api/rest/v1/generations/${generationId}`,
          {
            headers: {
              accept: 'application/json',
              Authorization: `Bearer ${LEONARDO_API_KEY}`,
            },
          }
        );

        const generationData = getResponse.data.generations_by_pk;

        if (generationData.status === 'COMPLETE' && 
            generationData.generated_images?.length > 0) {
          const imageUrl = generationData.generated_images[0].url;
          console.log(`✅ [${requestId}] Successfully generated image for:`, recipe?.title);
          
          // Сохраняем результат в кэш
          resultsCache.set(cacheKey, imageUrl);
          // Удаляем из активных запросов
          activeRequests.delete(cacheKey);
          
          return imageUrl;
        } else if (generationData.status !== 'PENDING') {
          break;
        }
      }

      throw new Error('Failed to generate image');
    })();

    // Сохраняем промис и время начала запроса
    activeRequests.set(cacheKey, {
      promise,
      timestamp: Date.now()
    });

    return promise;
  } catch (error) {
    console.error('❌ Leonardo API error:', error);
    // Удаляем из активных запросов в случае ошибки
    activeRequests.delete(cacheKey);
    throw error;
  }
}; 